<template>
  <component :is="as" :class="[VARIANTS[variant], PADDING[padding], interactive ? HOVER[variant] : '']">
    <slot />
  </component>
</template>

<script setup>
// The site's surfaces.
//
// `panel` a self-contained block of content: the extension's feature and
//         price boxes, dashboard and sign-in cards. 2px gray-800 rule on a
//         gray-900 fill.
// `frame` the page's own gray-950 inside a white/10 hairline — the API ad,
//         edged like the code window it contains.
// `tile`  one item in a grid of many (brand cards, logo cards): lighter, so a
//         page of them doesn't turn into a wall of boxes.
//
// `interactive` adds the hover state for cards that are links. Padding is a
// prop so it stays on the scale; `none` is for cards whose sections carry
// their own. Any element via `as`.
//
// This note lives here rather than as a comment at the top of the template:
// in development a root-level comment turns the template into a fragment, and
// a caller holding a ref to the card (ApiAccessCard observes it) would get a
// text node for `$el` instead of the element.
defineProps({
  as: { type: String, default: 'div' },
  variant: { type: String, default: 'panel' },
  padding: { type: String, default: 'md' },
  interactive: { type: Boolean, default: false },
})

const VARIANTS = {
  panel: 'rounded-xl border-2 border-gray-800 bg-gray-900 shadow',
  frame: 'rounded-xl border border-white/10 bg-gray-950 shadow',
  tile: 'rounded-xl border border-gray-800 bg-gray-900/40',
}

const HOVER = {
  panel: 'transition hover:border-gray-700',
  frame: 'transition hover:border-white/20',
  tile: 'transition hover:border-gray-700 hover:bg-gray-900',
}

const PADDING = {
  none: '',
  sm: 'p-4',
  md: 'p-5 sm:p-6',
  lg: 'p-6 sm:p-8',
}
</script>
